import { useCallback, useMemo, useState } from 'react';
import type { ShowcaseSignUpPlace, ShowcaseUpsellAction } from './showcaseActions';
import { trackShowcaseSignUpClicked, trackShowcaseUpsellShown } from './showcaseAnalytics';
import { musicVideoSignUpHref } from './musicVideoDemoPath';
import type { MusicVideoShowcaseContextValue } from './MusicVideoShowcaseContext';

/**
 * The state of the showcase mode: the open sign-up card (design c2) and the sign-up link. Opening a
 * card sends `showcase_upsell_shown { action }`; a sign-up button sends `showcase_signup_clicked`.
 */
export function useShowcaseContextValue(isEmbed: boolean): MusicVideoShowcaseContextValue {
  const [upsell, setUpsell] = useState<ShowcaseUpsellAction | null>(null);
  const showUpsell = useCallback((action: ShowcaseUpsellAction) => {
    setUpsell(action);
    trackShowcaseUpsellShown(action);
  }, []);
  const closeUpsell = useCallback(() => setUpsell(null), []);
  const onSignUp = useCallback((place: ShowcaseSignUpPlace) => trackShowcaseSignUpClicked(place), []);
  return useMemo(
    () => ({ isEmbed, signUpHref: musicVideoSignUpHref(), upsell, showUpsell, closeUpsell, onSignUp }),
    [closeUpsell, isEmbed, onSignUp, showUpsell, upsell]
  );
}
